export const passwordRequirements = [
  ["length", "At least 8 characters", (value) => value.length >= 8],
  ["lower", "One lowercase letter", (value) => /[a-z]/.test(value)],
  ["upper", "One uppercase letter", (value) => /[A-Z]/.test(value)],
  ["number", "One number", (value) => /\d/.test(value)],
  ["symbol", "One special character", (value) => /[^A-Za-z0-9]/.test(value)],
];

export const getPasswordStrength = (password = "") => {
  const checks = passwordRequirements.map(([key, label, test]) => ({ key, label, met: test(password) }));
  const score = checks.filter((check) => check.met).length;
  const label = score <= 2 ? "Weak" : score < passwordRequirements.length ? "Medium" : "Strong";
  const color = label === "Strong" ? "#15803d" : label === "Medium" ? "#b45309" : "#b91c1c";
  return { checks, score, label, color, valid: score === passwordRequirements.length };
};

export const passwordPolicyMessage = "Use at least 8 characters with uppercase, lowercase, a number, and a special character.";
